// extracted by mini-css-extract-plugin
export var quantityInput = "_dt-0";